import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "21",
        cy: "21",
        r: "21",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M21 14.346a1.4 1.4 0 0 0 1.023-.413 1.4 1.4 0 0 0 .413-1.023 1.4 1.4 0 0 0-.413-1.023A1.4 1.4 0 0 0 21 11.475a1.4 1.4 0 0 0-1.023.412 1.4 1.4 0 0 0-.413 1.023q0 .61.413 1.023a1.4 1.4 0 0 0 1.023.413M19.833 30.5h2.334V17.667h-2.334z"
      })
    ], -1)
  ])))
}
export default { render: render }